import { el, clear } from "../dom.js";
import type { RecommendationRule } from "../../content/types.js";

export function renderRecommendation(
  container: HTMLElement,
  recommendation: RecommendationRule,
  onPrimary: () => void,
  onSecondary: () => void,
  onContinue: () => void,
): void {
  clear(container);
  const buttons: HTMLElement[] = [
    el("button", { className: "btn", type: "button", "data-action": "primary" }, [
      recommendation.primaryCta,
    ]),
  ];
  if (recommendation.secondaryCta) {
    buttons.push(
      el("button", { className: "btn secondary", type: "button", "data-action": "secondary" }, [
        recommendation.secondaryCta,
      ]),
    );
  }

  const screen = el("section", { className: "screen" }, [
    el("span", { className: "eyebrow" }, ["Next step"]),
    el("h1", {}, ["10 · Recommendation."]),
    el("p", { className: "lede" }, [recommendation.reason]),
    el("div", { className: "btn-row" }, buttons),
    el("button", { className: "back-link", type: "button", "data-action": "continue" }, [
      "Carry on without choosing yet →",
    ]),
  ]);

  screen.querySelector('[data-action="primary"]')!.addEventListener("click", onPrimary);
  screen.querySelector('[data-action="secondary"]')?.addEventListener("click", onSecondary);
  screen.querySelector('[data-action="continue"]')!.addEventListener("click", onContinue);
  container.append(screen);
}
